"use client";

import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface ErrorBoundaryWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function ErrorBoundaryWrapper({ 
  children, 
  fallback = <p className="text-red-500 p-4">Something went wrong loading this component.</p> 
}: ErrorBoundaryWrapperProps) {
  return (
    <ReactErrorBoundary
      fallback={typeof fallback === 'function' ? fallback : <>{fallback}</>}
      onError={(error) => console.error('Error caught by ErrorBoundary:', error)}
    >
      {children}
    </ReactErrorBoundary>
  );
}
